import "@/assets/scss/ocb-layout.scss"

import "@streamllc/shared/views.css"

import { OCBView, OrderView, OrderViewLayout, TotalScreen, WelcomeView } from "@streamllc/shared/ocb"
import { useEffect } from "react"

import { OCBAppViews } from "@/entities/app/ocb/ocb.types"
import UnreachableCodeError from "@/shared/errors/UnreachableCodeError"
import useBroadcastChannel from "@/utils/hooks/useBroadcastChannel"
import useBroadcastMessage from "@/utils/hooks/useBroadcastMessage"
import useParam from "@/utils/hooks/useParam"
import { mockOrder } from "@/utils/ocb-preview"
import BroadcastHandshake from "@/utils/transform/BroadcastHandshake"

function OrderWrapper(props: { children: React.ReactNode, layout?: OrderViewLayout }) {
  return (
    <div className={props.layout === 5 ? "ocb-layout_5" : "ocb-layout"}>
      {props.children}
    </div>
  )
}

function OCBPreview() {
  const appName = useParam("app")

  const channel = useBroadcastChannel(`OCB/${appName}/PREVIEW`)
  useEffect(() => channel.postMessage({ type: "CONNECT", payload: crypto.randomUUID() }), [channel])
  useEffect(() => BroadcastHandshake.pong(channel), [channel])

  const { view, views } = useBroadcastMessage<{ view: OCBView, views: OCBAppViews }>(channel, "UPDATE") || {}

  if (views == null) return

  if (view === OCBView.Order) {
    const layout = views.order.layout
    return (
      <OrderWrapper layout={layout}>
        <OrderView isCustomizing={layout === 5} order={mockOrder} customization={views.order} showVerticalImage />
      </OrderWrapper>
    )
  }

  if (view === OCBView.Welcome) {
    return <WelcomeView customization={views.welcome} />
  }

  if (view === OCBView.Total) {
    return <TotalScreen customization={views.totalScreen} total={32} />
  }

  throw new UnreachableCodeError
}

export default OCBPreview

OCBPreview.header = () => <></>
